import { createContext, PropsWithChildren, useContext, useMemo } from 'react'

export type TooltipContext = {
  disabled?: boolean
  inverted?: boolean
  arrow?: boolean
  /** Overrides the arrow fill (e.g. to match a custom panel background). */
  arrowClassName?: string
  interactive?: boolean
}

export const TooltipContext = createContext<TooltipContext>(undefined)

export const useTooltipContext = () => {
  const context = useContext(TooltipContext)
  if (context === undefined) {
    throw new Error('useTooltipContext must be used within a TooltipProvider')
  }
  return context
}

export const TooltipContextProvider = ({
  children,
  disabled,
  inverted,
  arrow,
  arrowClassName,
  interactive,
}: PropsWithChildren<TooltipContext>) => {
  const context = useMemo(
    () => ({
      disabled,
      inverted,
      arrow,
      arrowClassName,
      interactive,
    }),
    [arrow, arrowClassName, disabled, inverted, interactive],
  )

  return (
    <TooltipContext.Provider value={context}>
      {children}
    </TooltipContext.Provider>
  )
}
